// @flow
import type { UploadCallbacksData, CallbacksOptions } from "uploader";
import { getLogger } from "@cld/upload-widget";
import handleResize from "utils/cropUtils/resizeHelper";
import { types as ats } from "../store/actions";
import * as fileMethods from "./uploadFileMethods";

const logger = getLogger();

const updateCropData = (data: UploadCallbacksData, options: CallbacksOptions) => {
	const fileData = fileMethods.getFileDataForId(data.uniqueId, options);
	const dimensions = fileData.imageDimensions;

	if (fileData.customCoordinates) {
		// dont calculate again for file that was already resized
		if (!fileData.coordinatesResize) {
			let updatedData = {
				changed: false,
				customCoordinates: fileData.customCoordinates,
			};

			// calculate resized dimensions due to image resize
			updatedData = handleResize(data, updatedData, dimensions);

			if (updatedData.changed) {
				logger.log("[uploader.uploadCallbacks] crop coordinates have changed!",
					{
						prev: fileData.customCoordinates,
						next: updatedData.customCoordinates,
						dimensions,
					});

				options.actions[ats.SET_UPLOADER_FILE_COORDINATES]({
					id: data.uniqueId,
					customCoordinates: updatedData.customCoordinates,
					coordinatesResize: true,
				});
			}
		} else {
			// must reset the coordinatesResize flag in case it was set before so we dont get into infinite loop
			options.actions[ats.SET_UPLOADER_FILE_COORDINATES]({
				id: data.uniqueId,
				customCoordinates: fileData.customCoordinates,
				coordinatesResize: false,
			});
		}
	}
};

export {
	updateCropData,
};
